export default __webpack_public_path__ + "09a49e9.png";